import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Modal, Typography } from 'antd'
import { SendOutlined } from '@ant-design/icons'

import LalamoveForm from '../../lalamove/form'


const SendLalamove = ({ orderId, refetch = () => {} }) => {
    const { i18n } = useTranslation('inquiries')
    const [showForm, setShowForm] = useState(false)

    const toggleForm = () => {
        setShowForm(!showForm)
    }

    return (
        (<div>
            <Typography.Link onClick={toggleForm}>
                <SendOutlined /> {i18n.t('inquiries:lalamove.sendLalamove')}
            </Typography.Link>
            <Modal
                title={i18n.t('inquiries:lalamove.sendLalamove')}
                open={showForm}
                onCancel={toggleForm}
                destroyOnClose
                footer={null}
            >
                <LalamoveForm orderId={orderId}
                    fetchOrder={refetch}
                    onToggleForm={toggleForm} />
            </Modal>
        </div>)
    );
}

SendLalamove.propTypes = {
    orderId: PropTypes.string.isRequired,
    refetch: PropTypes.func
}

export default SendLalamove
